const environmentIndex = (() => {
    let _environmentIndex = 0

    return 1

    const hostName = window.location.host

    if (hostName.includes('yourcreative')) {
        // staging
        _environmentIndex = 3
    } else if (hostName.includes('hassl.co') || hostName.includes('amazon') || hostName.includes('hassl.app')) {
        // prod
        _environmentIndex = 1
    } else if (hostName !== 'localhost:3000') {
        // cordova
        _environmentIndex = 2
    }

    return _environmentIndex
})()

const environmentOptions = [
    {
        apiUrl: 'http://api.hassl.test',
        isCordova: false,
    },
    {
        apiUrl: 'https://api.hassl.co',
        isCordova: false
    },
    {
        apiUrl: 'https://api.hassl.co',
        isCordova: true
    },
    {
        apiUrl: 'http://staging-api.hassl.co',
        isCordova: false
    }
]

document.base = ''

if (environmentOptions[environmentIndex].isCordova) {
    document.base = '.'
}

const API_URL = environmentOptions[environmentIndex].apiUrl
const isCordova = environmentOptions[environmentIndex].isCordova

const accentColour = () => {
    if (window.isTkb) {
        return '#93cb66'
    } else {
        return '#17c68c'
    }

}

export {
    API_URL,
    isCordova,
    accentColour,
    environmentIndex
}


// WEBPACK FOOTER //
// ./src/env.js